// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"96e3fdfa","488":"a5a86945","573":"51d9d756","626":"1db4b77e"}[chunkId] + ".chunk.css";
};